// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2ded_","requiredAsterisk":"Info_requiredAsterisk__1BuMG"};